import React, { memo, useMemo, useEffect, useCallback } from 'react';
import { Text, Pressable } from 'react-native';
import { Container, Panel, ActionButtons, DataTable, Navigation, AddButton } from '../components';
import { PENDING } from '../../actions/statusTypes';
import { THEME } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getEmployers } from './slice';

const Actions = memo(function Actions(props) {
  const item = props.item;
  return (
    <ActionButtons
      item={item}
      onInfoPress={props.handlers?.onInfoPress}
      onRejectPress={props.handlers?.onRejectPress}
      onEditPress={props.handlers?.onEditPress}
    />
  );
});

const Internal = memo((props) => {
  useEffect(() => {
    if (props.status === PENDING) {
      props.actions.getEmployers();
    }
  }, [props.status]);

  const rowData = useMemo(() => {
    return props.employers?.map((employer) => ({
      ...employer,
      address: employer.location?.address,
      eventTypes: employer.eventTypesConfiguration?.eventTypesPublic?.join(', '),
      key: employer.employerId,
    }));
  }, [props.employers]);

  const handlers = useMemo(() => {
    return {
      onInfoPress: (item) => {
        Navigation.showModal({
          screen: 'BaseConfigForm',
          passProps: { employer: item, activeStep: 1, readonly: true },
        });
      },
      onRejectPress: (item) => {
        console.info('>>> Reject Pressed:', item);
      },
      onEditPress: (item, step = 1) => {
        Navigation.showModal({
          screen: 'BaseConfigForm',
          passProps: { employer: item, activeStep: step },
        });
      },
    };
  }, []);

  const columnData = useMemo(() => {
    const cols = [
      {
        headerLabel: 'EMPLOYER',
        style: { flexGrow: 0.2, width: 160 },
        dataAccessor: 'name',
      },
      {
        headerLabel: 'TIME ZONE',
        style: { flexGrow: 0.2, width: 160 },
        extraRowTextStyle: { fontSize: 14 },
        dataAccessor: 'timeZone',
      },
      {
        headerLabel: 'EVENT TYPES',
        style: { flexGrow: 0.2, width: 150 },
        dataAccessor: (item) => (
          <Pressable
            onPress={() => {
              handlers.onEditPress(item, 4);
            }}
          >
            <Text numberOfLines={1} style={[THEME.linkStyle, { marginRight: 25 }]}>
              {item.eventTypes}
            </Text>
          </Pressable>
        ),
      },
    ];
    cols.push({
      headerLabel: 'ACTIONS',
      style: { flexGrow: 0.1, width: 50 },
      extraRowStyle: { paddingLeft: 5 },
      dataAccessor: (item) => <Actions item={item} {...props} handlers={handlers} />,
    });
    return cols;
  }, []);

  const handleAddPress = useCallback(() => {
    Navigation.showModal({ screen: 'BaseConfigForm', passProps: { activeStep: 1 } });
  }, []);
  function renderAddButton() {
    return (
      <AddButton
        label="ADD"
        onPress={handleAddPress}
        containerStyle={{ height: 40, paddingRight: 10 }}
      />
    );
  }
  return (
    <Container scrollView={true}>
      <Panel title="DOD Employers" extraHeaderContent={renderAddButton()}>
        <DataTable columns={columnData} data={rowData} altColors={true} />
      </Panel>
    </Container>
  );
});

function mapStateToProps(state) {
  return {
    status: state.screens.baseConfig.status,
    saveEmployerError: state.screens.baseConfig.saveEmployerError,
    employers: state.screens.baseConfig.employers,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getEmployers }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Internal);
